module.exports = __webpack_public_path__ + "static/media/KaTeX_SansSerif-Regular.badf3598.woff2";